import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { TypedUseSelectorHook } from 'react-redux';
import authReducer from './slices/authSlice';
import suppliersReducer from './slices/suppliersSlice';
import storesReducer from './slices/storesSlice';
import loaderReducer from './slices/loaderSlice';
import snackbarReducer from './slices/snackbarSlice';
import productsReducer from './slices/productsSlice';
import languageReducer from './slices/languagesSlice';
import categoryReducer from './slices/categorySlice';
import subCategoryReducer from './slices/subCategorySlice';
import userProfileReducer from './slices/GetUserProfileSlice';
import citiesReducer from './slices/citiesSlice';
import statesReducer from './slices/statesSlice';
import messagesReducer from './slices/messagesSlice';
import taxesReducer from './slices/taxesSlice';
import countryReducer from './slices/countriesSlice';
import dropdownDataReducer from './slices/dropdownDataSlice';

export const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    loader: loaderReducer,
    auth: authReducer,
    suppliers: suppliersReducer,
    stores: storesReducer,
    products: productsReducer,
    languages: languageReducer,
    category: categoryReducer,
    subCategory: subCategoryReducer,
    userProfile: userProfileReducer,
    cities: citiesReducer,
    states: statesReducer,
    messages: messagesReducer,
    taxes: taxesReducer,
    country: countryReducer,
    dropdownData: dropdownDataReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['your/action/type'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates']
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
